// extracted by mini-css-extract-plugin
export default {"navitem":"TabNavItem_navitem__ajrGb","navitemtext":"TabNavItem_navitemtext__KhBsf","active":"TabNavItem_active__okG7C"};